<div class="product-events__header">
    <div class="product-events__title">
        <h1>{{ 'admin.product.event.title.events' | translate }}</h1>
    </div>
</div>
<div class="product-events__container">
    <pf-loading-overlay />
    <div class="product-events__filter">
        @if (isMobile()) {
        <button type="button" class="product-events__filter-toggle" (click)="toggleMobileFilter()">
            <mat-icon>{{ isMobileFilterOpen() ? 'expand_less' : 'filter_list' }}</mat-icon>
            <span>{{ 'admin.product.event.button.filters' | translate }}</span>
        </button>
        }

        <form action="product-event_filters" class="product-events__filter-form"
            [class.product-events__filter-form--hidden]="!shouldShowFilters()" [formGroup]="productEventsFilter"
            (submit)="updateProductEventsByFilter()">
            <div class="product-events__filter-field">
                <label for="product-event-type">{{ 'admin.product.event.field.eventType' | translate }}:</label>
                <pf-select [options]="productEventTypeOptions" [multiMode]="true"
                    [initialSelectedIds]="savedProductEventTypes()"
                    (selectionChange)="onProductEventTypesChange($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-products">{{ 'admin.product.event.field.productName' | translate }}:</label>
                <pf-select [options]="productOptions" [multiMode]="true" [initialSelectedIds]="savedProductIds()"
                    (selectionChange)="onProductIdsChange($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-from-storage-type">{{ 'admin.product.event.field.fromStorage' | translate
                    }}:</label>
                <pf-select [options]="fromStorageTypeOptions()" [initialSelectedId]="savedFromStorageType()"
                    (singleSelectionChange)="onFromStorageTypeSelect($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-to-storage-type">{{ 'admin.product.event.field.toStorage' | translate
                    }}:</label>
                <pf-select [options]="toStorageTypeOptions()" [initialSelectedId]="savedToStorageType()"
                    (singleSelectionChange)="onToStorageTypeSelect($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-partners">{{ 'admin.product.event.field.partnerName' | translate }}:</label>
                <pf-select [options]="partnerOptions" [multiMode]="true" [initialSelectedIds]="savedPartnerIds()"
                    (selectionChange)="onPartnerIdsChange($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-festivals">{{ 'admin.product.event.field.festivalName' | translate }}:</label>
                <pf-select [options]="festivalOptions" [multiMode]="true" [initialSelectedIds]="savedFestivalIds()"
                    (selectionChange)="onFestivalIdsChange($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-preorder">{{ 'admin.product.event.field.preorder' | translate }}:</label>
                <pf-select [options]="preorderOptions()" [initialSelectedId]="savedPreorder()"
                    (singleSelectionChange)="onPreorderSelect($event)" />
            </div>
            <div class="product-events__filter-field">
                <label for="product-event-reprint">{{ 'admin.product.event.field.reprint' | translate }}:</label>
                <pf-select [options]="reprintOptions()" [initialSelectedId]="savedReprint()"
                    (singleSelectionChange)="onReprintSelect($event)" />
            </div>
            <div class="product-events__filter-field">
                <label>{{ 'admin.product.event.field.startDate' | translate }}:</label>
                <pf-datepicker [multiMode]="true" [initialStartDate]="savedStartDate()"
                    [initialEndDate]="savedEndDate()" [maxDate]="maxDate"
                    (selectedStartDate)="onStartDateChange($event)" (selectedEndDate)="onEndDateChange($event)" />
            </div>
        </form>
        <div class="product-events__filter-actions">
            <button class="product-events__search-btn" type="button" (click)="updateProductEventsByFilter()">
                <mat-icon>search</mat-icon>
                <span>{{ 'admin.product.event.button.search' | translate }}</span>
            </button>
            <button class="product-events__reset-btn" type="button" (click)="onResetFilters()">
                <mat-icon>refresh</mat-icon>
                <span>{{ 'PRODUCT_EVENTS.RESET_FILTERS' | translate }}</span>
            </button>
        </div>
    </div>
    @if (productEvents) {
    <pf-pagination [requestedPage]="requestedPage" [requestedPageSize]="requestedPageSize" [totalItems]="totalItems"
        (pageChanged)="onPaginationChange($event)" />
    @if (isMobile()) {
    <div class="product-events__cards">
        @for (productEvent of productEvents; track $index; let i = $index) {
        <pf-card [id]="'product-event-id-' + productEvent.id" [itemId]="i" [itemTitle]="productEvent.productName"
            [itemSubTitle]="productEvent.partnerName"
            [itemContent]="'admin.product.event.type.' + getProductEventTypeByValue(productEvent.productEventType) | translate"
            [itemQuantity]="`${productEvent.quantity}db`" [itemDate]="productEvent.eventDate"
            [editable]="isModifiable(productEvent)" (closeCard)="onRemoveClicked(i)" (editCard)="onEdit(i)" />
        }
    </div>
    } @else {
    <div class="product-events__table">
        <table>
            <thead>
                <tr>
                    <th>{{ 'admin.product.event.field.eventType' | translate }}</th>
                    <th>{{ 'admin.product.event.field.productName' | translate }}</th>
                    <th>{{ 'admin.product.event.field.reprint' | translate }}</th>
                    <th>{{ 'admin.product.event.field.preorder' | translate }}</th>
                    <th>{{ 'admin.product.event.field.partnerName' | translate }}</th>
                    <th>{{ 'admin.product.event.field.festivalName' | translate }}</th>
                    <th>{{ 'admin.product.event.field.fromStorage' | translate }}</th>
                    <th>{{ 'admin.product.event.field.toStorage' | translate }}</th>
                    <th>{{ 'admin.product.event.field.referenceNumber' | translate }}</th>
                    <th>{{ 'admin.product.event.field.quantity' | translate }}</th>
                    <th>{{ 'admin.product.event.field.unitPrice' | translate }}</th>
                    <th>{{ 'admin.product.event.field.eventDate' | translate }}</th>
                    <th>{{ 'admin.product.event.field.comment' | translate }}</th>
                    <th>{{ 'admin.product.event.field.action' | translate }}</th>
                </tr>
            </thead>
            <tbody>
                @for (productEvent of productEvents; track $index) {
                <tr class="product-events__table-row">
                    <a class="product-events__table-link">
                        <td>
                            {{
                            'admin.product.event.type.' + getProductEventTypeByValue(productEvent.productEventType)
                            | translate
                            }}
                        </td>
                    </a>
                    <td>{{ productEvent.productName }}</td>
                    <td>
                        @if (productEvent.reprint) {
                        <mat-icon>check</mat-icon>
                        } @else {
                        <mat-icon>close</mat-icon>
                        }
                    </td>
                    <td>
                        @if (productEvent.wasPreorder) {
                        <mat-icon>check</mat-icon>
                        } @else {
                        <mat-icon>close</mat-icon>
                        }
                    </td>
                    <td>{{ productEvent.partnerName }}</td>
                    <td>{{ productEvent.festivalName }}</td>
                    <td>
                        {{
                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.fromStorageType)
                        | translate
                        }}
                    </td>
                    <td>
                        {{
                        'admin.product.event.storage.' + getStorageTypeDisplayValue(productEvent.toStorageType) |
                        translate
                        }}
                    </td>
                    <td>{{ productEvent.referenceNumber }}</td>
                    <td>{{ productEvent.quantity | number: '1.0-0' : 'hu-HU' }}</td>
                    <td>{{ productEvent.unitPrice | number: '1.0-0' : 'hu-HU' }}</td>
                    <td>{{ productEvent.eventDate | dateUtil }}</td>
                    <td>{{ productEvent.comment }}</td>
                    <td>
                        <div class="product-events__row-actions">
                            <div class="product-events__row-action"
                                [class.product-events__row-action--hidden]="!isModifiable(productEvent)">
                                <button class="product-events__row-action-btn" type="button" (click)="onEdit($index)">
                                    <mat-icon>edit</mat-icon>
                                </button>
                            </div>
                            <div class="product-events__row-action"
                                [class.product-events__row-action--hidden]="!isModifiable(productEvent)">
                                <button class="product-events__row-action-btn delete-btn" type="button"
                                    (click)="onRemoveClicked($index)">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </div>
                        </div>
                    </td>
                </tr>
                }
            </tbody>
        </table>
    </div>
    }
    <pf-pagination [requestedPage]="requestedPage" [requestedPageSize]="requestedPageSize" [totalItems]="totalItems"
        (pageChanged)="onPaginationChange($event)" />
    } @else {
    <div>{{ 'admin.product.event.error.pageLoad' | translate }}</div>
    }
</div>